import { TariffStatusType } from '../models/types'

/**
 * Sorting function used to sort tariff status inside tariff table for all screens devices
 * Ascending: "active", "inactive" , "not in use", "expired"
 * Descending: "expired", "inactive", "not in use", "active"
 */
export const tariffStatusSortFn = (tariffStatusA: TariffStatusType, tariffStatusB: TariffStatusType): number => {
  const statusOrder: Record<TariffStatusType, number> = {
    active: 0,
    inactive: 1,
    'not-in-use': 2,
    expired: 3,
  }

  return statusOrder[tariffStatusA] - statusOrder[tariffStatusB]
}
